import { Component, OnInit, signal, Input, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PropertyService } from '../../../_services/properties/property.service';
import { InrShortPipe } from '../../../_pipes/indian-currency.pipe';
import { ToastService } from '../../../_services/toast.service';
import {
  CommonModule,
  CurrencyPipe,
  NgClass,
  NgFor,
  NgIf,
  TitleCasePipe,
} from '@angular/common';
import { GalleryComponent } from '../../gallery/gallery.component';
import { FloorPlanViewerComponent } from '../../search/floor-plan-viewer/floor-plan-viewer.component';
import { SharingdataService } from '../../../_services/sharingdata.service';
import { LoaderService } from '../../../_services/loader.service';
import { NumberFormatPipe } from '../../../_pipes/number-format.pipe';

export type Amenities = Record<string, boolean>;

@Component({
  selector: 'app-property-view',
  imports: [
    GalleryComponent,
    NgFor,
    InrShortPipe,
    CommonModule,
    NumberFormatPipe,
  ],
  templateUrl: './property-view.component.html',
  styleUrl: './property-view.component.scss',
})
export class PropertyViewComponent implements OnInit {
  shareToken: string | null = null;
  DEFAULT_ICON = 'M12 4v16m8-8H4';
  property: any;
  selectedItem: any = signal({});
  isLoading = false;
  properties: any = signal([]);
  showSuccessModal: boolean = false;
  expandedIndex: number | null = 0;
  @Input() isMobileFullView = false;
  @Input() propertyList: any[] = [];
  isMobile = window.innerWidth < 768;
  favCount: number = 0;
  activeTab: any = 'all-listings';
  showDetailView = false;

  favProperties: any[] = [];
  errorMsg = '';
  removingId: string | null = null;
  togglingId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private propertyService: PropertyService,
    public readonly _PS: PropertyService,
    private readonly _NS: ToastService,
    private router : Router

  ) {}

  

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth < 768;
  }
  selectPropertyMobile(property: any) {
    this.selectedPropery(property);

    if (this.isMobile) {
      this.showDetailView = true;
    }
  }
  handlePropertyClick(property: any) {
    this.selectedPropery(property);

    if (this.isMobile) {
      this.showDetailView = true;
    }
  }
  propertyRequest(propertyId: any) {
    this.isLoading = true;
    this._PS.propertyReq(propertyId).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res.status) {
          this._NS.success(res.message || 'Request submitted successfully!');
          this.openSuccessModal();
        } else {
          this._NS.error(
            res.message || 'Something went wrong. Please try again.'
          );
        }
      },
      error: (err: any) => {
        this.isLoading = false;
        const errorMsg = err.message || 'Server connection failed';
        this._NS.error(errorMsg);
      },
    });
  }

  ngOnInit(): void {
    // 1. Get the token from the URL
    this.shareToken = this.route.snapshot.paramMap.get('sheredToken');
    console.log(this.shareToken)
    if (this.shareToken) {
      this.loadProperty(this.shareToken);
    }
    const savedData = localStorage.getItem('resturnUrl');

    if (savedData) {
      localStorage.removeItem('resturnUrl');
    } else {
      console.log('No resturnUrl draft found to delete.');
    }
    this.loadFavs();
    this._PS.favList$.subscribe((list) => {
      this.loadFavs();
    });
  }
  toggleExpand(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }
  loadProperty(token: string) {
    this.propertyService.getPublicProperty(token).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.properties.set(res.data);
          this.selectedPropery(res.data[0])
        } else {
          this._NS.error(res.message);
          const returnUrl = this.router.url;
          this.router.navigate(['mismatch-user'], {
            queryParams: {
              returnUrl: returnUrl
            }
          })
        }
       ;
      },
      error: (err) => {
        // console.error('Property not found or link expired', err);
      },
    });
  }

  selectedPropery(property: any) {
    this.selectedItem.set(property);
  }
  getPriceRange(price?: any) {
    const prices = price ?? this.selectedItem().price; // Access your array

    if (!Array.isArray(prices) || prices.length === 0) return null;

    const numericValues = prices.map((p) => p.price);
    const min = Math.min(...numericValues);
    const max = Math.max(...numericValues);

    return { min, max, isSame: min === max };
  }
  openSuccessModal(): void {
    this.showSuccessModal = true;
  }

  closeSuccessModal(): void {
    this.showSuccessModal = false;
  }
  // Add this function inside your class
  formatAddress(item: any): string {
    if (!item) return '';

    return [
      item.name,
      item.address,
      item.streetName,
      item.cityName,
      item.stateName,
    ]
      .filter((part) => part && part.trim() !== '') // Removes null, undefined, or empty strings
      .join(', '); // Joins them with a single space
  } 
  formatAddressSide(property: any): string {
    if (!property) return '';

    const cleanCluster = property?.microMarket?.cluster
      ?.replace(/\s*\(.*?\)/g, '')
      ?.trim();

    const microMarket = property?.microMarket?.micromarketName;

    return [microMarket, cleanCluster].filter(Boolean).join(', ') || 'N/A';
  }
  getRoomIcon(room: string): string {
    const icons: { [key: string]: string } = {
      'Servant Room': 'fa-solid fa-user-tie',
      'Study Room': 'fa-solid fa-book-open',
      'Store Room': 'fa-solid fa-boxes-stacked',
      'Media Room': 'fa-solid fa-film',
      'Pooja Room': 'fa-solid fa-om',
      'Guest Room': 'fa-solid fa-bed',
    };
    // Returns the icon class or a default house icon if not found
    return icons[room] || 'fa-solid fa-door-open';
  }
  readonly AMENITY_MAP: Record<string, { label: string; icon: string }> = {
    // Common / General
    air_conditioned: { label: 'AC', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    wifi: {
      label: 'Wi-Fi',
      icon: 'M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.343 9.257c5.858-5.858 15.355-5.858 21.213 0',
    },
    power_backup: { label: 'Power Backup', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    vaastu: {
      label: 'Vaastu Compliant',
      icon: 'M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707',
    },
    private_pool: {
      label: 'Private Pool',
      icon: 'M21 16v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5m16-4v1M5 12v1m11-1h2m-10 0H7m4-1v2m-1 1h2',
    },
    sky_villa: {
      label: 'Sky Villa',
      icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    },
    skydeck: {
      label: 'Skydeck',
      icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
    },
    sea_facing: {
      label: 'Sea Facing',
      icon: 'M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z',
    },
    club_house: {
      label: 'Club House',
      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    },
    banquet_hall: {
      label: 'Banquet Hall',
      icon: 'M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9',
    },
    cafeteria: {
      label: 'Cafeteria',
      icon: 'M3 10h18l-2 4H5l-2-4zm8-6h2V7h-2V4zm0 10h2v6h-2v-6z',
    },
    bar_lounge: {
      label: 'Bar & Lounge',
      icon: 'M10 2l3 9h-6l3-9zm0 18v-2m4 2v-4m-8 4v-6',
    },
    tennis_courts: {
      label: 'Tennis Courts',
      icon: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    },
    golf_course: {
      label: 'Golf Course',
      icon: 'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
    },
    park: {
      label: 'Park',
      icon: 'M5.5 14a2 2 0 012-2 2 2 0 012 2v6h-4v-6zM14.5 10a3 3 0 013-3 3 3 0 013 3v10h-6V10z',
    },
    smart_home: {
      label: 'Smart Home',
      icon: 'M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002-2z',
    },
    fingerprint_access: {
      label: 'Fingerprint',
      icon: 'M12 11V7a4 4 0 018 0v4M5 11h14a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2z',
    },
    intercom: {
      label: 'Intercom',
      icon: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z',
    },
    piped_gas: {
      label: 'Piped Gas',
      icon: 'M12 21a9.003 9.003 0 008.312-5.551L12 13V3a9 9 0 100 18z',
    },
    ro_water: {
      label: 'RO Water',
      icon: 'M19.428 15.341A8 8 0 114.412 15c.118-.364.418-.7.778-.711 1.05-.033 1.74-.74 1.74-1.487a4.25 4.25 0 00-8.5 0c0 .747.69 1.454 1.74 1.487.36.011.66.347.778.711a8 8 0 1115.357-3.341z',
    },
    rainwater_harvesting: {
      label: 'Rainwater Harvesting',
      icon: 'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0a2 2 0 01-2 2H6a2 2 0 01-2-2m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5',
    },
    private_terrace: {
      label: 'Private Terrace',
      icon: 'M15 10.5a3 3 0 11-6 0 3 3 0 016 0zM19.5 10.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z',
    },
    private_garage: {
      label: 'Private Garage',
      icon: 'M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M3.75 9h16.5M4.5 12h15',
    },
    private_jacuzzi: {
      label: 'Private Jacuzzi',
      icon: 'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0a2 2 0 01-2 2H6a2 2 0 01-2-2m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5',
    },
    gymnasium: {
      label: 'Gym',
      icon: 'M6 10v4m0 0h2m-2 0H4m12-4v4m0 0h2m-2 0h-2M8 12h8'
    },

    swimming_pool: {
      label: 'Swimming Pool',
      icon: 'M2 12c2-2 4-2 6 0s4 2 6 0 4-2 6 0M2 16c2-2 4-2 6 0s4 2 6 0 4-2 6 0'
    },

    security: {
      label: 'Security',
      icon: 'M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4z'
    },

    visitor_parking: {
      label: 'Visitor Parking',
      icon: 'M3 13l1-3h16l1 3M5 16h14M6 16v2m12-2v2M8 13V9h8v4'
    },

    maintenance_staff: {
      label: 'Maintenance',
      icon: 'M11 3a1 1 0 011 1v2.07a7.002 7.002 0 015.93 5.93H20a1 1 0 110 2h-2.07a7.002 7.002 0 01-5.93 5.93V20a1 1 0 11-2 0v-2.07a7.002 7.002 0 01-5.93-5.93H4a1 1 0 110-2h2.07a7.002 7.002 0 015.93-5.93V4a1 1 0 011-1z'
    },

    security_24x7: {
      label: 'Security 24 x 7',
      icon: 'M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4zM9 12l2 2 4-4'
    },

    lift: {
      label: 'Lift',
      icon: 'M8 4h8M8 20h8M12 8v8M10 10l2-2 2 2M10 14l2 2 2-2'
    }
  };
  hasAmenity(
    amenities: Amenities | null | undefined,
    key: keyof typeof this.AMENITY_MAP
  ): boolean {
    if (!amenities) return false;
    return amenities[key as string] === true;
  }
  getVisibleAmenities(amenitiesObj: any) {
    if (!amenitiesObj) return [];

    return Object.keys(amenitiesObj)
      .filter((key) => !!amenitiesObj[key] && key !== 'undefined')
      .map((key) => ({
        key,
        label: this.AMENITY_MAP[key]?.label || this.formatKey(key),
        icon: this.AMENITY_MAP[key]?.icon || this.DEFAULT_ICON,
      }));
  }
  formatKey(key: string) {
    return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
  showFullPrice: boolean = false;

  togglePrice() {
    this.showFullPrice = !this.showFullPrice;
  }
  formatBuildingStr(input: any): string {
    if (!input || typeof input !== 'string') return 'Invalid Input';
    const clean = input.replace(/[,+]/g, ' ').toUpperCase().trim();
    const parts = clean.split(/\s+/);
    if (parts.length < 3) return 'Invalid Format';
    const [block, ground, floor] = parts;
    return `${block}, ${ground}+${floor}`;
  }
  // In any property card component
  loadFavs(): void {
    this.isLoading = true;

    this._PS.getFavs().subscribe({
      next: (res) => {
        this.favProperties = res.data ?? [];

        // 🔥 FORCE UI refresh
        this.favProperties = [...this.favProperties];

        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this._NS.error(err.message);
      },
    });
  }

  togglingFavId: string | null = null;

  toggleFav(event: Event, propertyId: string): void {
  event.stopPropagation();

  const isFav = this.favProperties.some(p => p._id === propertyId);

  this.togglingFavId = propertyId;

  const action$ = isFav
    ? this._PS.removeFav(propertyId)
    : this._PS.addFav(propertyId);

  action$.subscribe({
    next: (res) => {
      this.togglingFavId = null;

      if (isFav) {
        this.favProperties = this.favProperties.filter(
          (p: any) => p._id !== propertyId
        );
      } else {
        if (res?.data) {
          this.favProperties = [...this.favProperties, res.data];
        }
      }
    },
    error: (err) => {
      this.togglingFavId = null;

      // 👇 important fallback
      if (err.message?.includes('not found')) {
        this.favProperties = this.favProperties.filter(
          (p: any) => p._id !== propertyId
        );
      }

      this._NS.error(err.message);
    },
  });
}
  
  get getTabData() {
    return [
      {
        id: 'all-listings',
        label: 'All listings',
        count: this.properties().length,
      },
      {
        id: 'favorites',
        label: 'Favorites',
        count: this.favProperties.length ?? 0,
      },
      { id: 'recently-viewed', label: 'Recently viewed', count: 0 },
    ];
  }
  onTabChange(tab: string): void {
    this.activeTab = tab;
  }
  onFilterClick(): void {}

  get filteredProperties() {
    const list = this.properties();

    if (this.activeTab === 'favorites') {
      return list.filter((p: any) =>
        this.favProperties.some(f => f._id === p._id)
      );
    }

    return list;
  }
  isFav(id: string): boolean {
    return this.favProperties.some(p => p._id === id);
  }
}
